<template>
  <div id="mb-info">
    <svg
      class="info-btn"
      viewBox="0 0 24 24"
      fill="white"
      width="5vw"
      height="5vw"
      :style="{ left: leftPos + 'vw' }"
      @click="status = !status"
    >
      <path
        d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </svg>
    <transition name="info-left">
      <div v-if="status" class="mb-info-left-curtain" @click="status = false"></div>
    </transition>
    <transition name="info-right">
      <div v-if="status" class="mb-info-right-curtain" :style="{ background: backgroundStyle }">
        <div :key="'info' + i" v-for="(ele, i) in info" style="margin-top: 5px">
          <hr v-if="ele.line" />
          <h4 v-if="ele.title" v-html="ele.title"></h4>
          <div :key="'info-index' + i + '-' + i2" v-for="(ele2, i2) in ele.index">
            <span v-html="ele2"></span>
            <br />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'mb-info',
  props: {
    leftPos: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    backgroundStyle: {
      type: String,
      default: function () {
        return 'white';
      },
    },
    info: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      status: false,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  mounted() {},
  methods: {
    showData(key) {
      const multibookType = this.$store.getters.multibookType;
      let pres = this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
      let data = pres.get(key);
      if (data.unactive) {
        return true;
      } else return false;
    },
    returnTitle(key) {
      const multibookType = this.$store.getters.multibookType;
      let pres = this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
      let data = pres.get(key);
      if (data.tooltip) {
        return data.tooltip;
      } else return 'Prezentacja';
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    pleaseShowMePresentation(id) {
      if (this.showData(id)) {
      } else {
        const multibookType = this.$store.getters.multibookType;
        this.$store.commit(
          'STATE_PRESENTATION_CONFIG',
          require(`__staticDir/${multibookType}/presentation/${id}/config.js`).default
        );
        this.$store.commit('STATE_PRESENTATION_SHOW', true);
        if (this.$store.getters.getPresentationConfig) {
          this.$router.push('/presentation/' + id);
        }
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    // homeIcon() {
    //   return require(`__mainSrcDir/assets/icons/info-48px.svg`);
    //   // return require(`src/renderer/assets/icons/home-48px.svg`);
    // },
  },
};
</script>

<style lang="sass">
$break-large: 1400px
#mb-info
  background: #0054a3
  overflow: hidden
  color: white
  .mb-info-left-curtain
    width: 50vw
    top: 0
    left: 0
    min-height: calc(var(--vh, 1vh)*100)
    z-index: 4
    background: #00000080
    position: fixed
  .mb-info-right-curtain
    overflow-y: scroll
    width: 50vw
    top: 0
    right: 0
    z-index: 4444
    background: white
    position: fixed
    min-height: calc(var(--vh, 1vh)*100)
    max-height: 100%
    padding: 2.5%

.presentation-items-scroll::-webkit-scrollbar-track
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
	background-color: #0054a3

.presentation-items-scroll::-webkit-scrollbar
	width: 10px
	background-color: #0054a3

.presentation-items-scroll::-webkit-scrollbar-thumb
	background-color: #309de4
	border: 2px solid #309de4

.info-left-leave-active, .info-left-enter-active
  transition: all .5s .0s linear

.info-left-leave-to, .info-left-enter
  transform: translateX(-50vw)
  opacity: 0
.info-right-leave-active, .info-right-enter-active
  transition: all .5s .0s linear

.info-right-leave-to, .info-right-enter
  transform: translateX(50vw)
  opacity: 0
.info-btn
  position: absolute
  top: 0
  left: 0
  z-index: 5
  padding-left: 1rem
  padding-right: 1rem
  transition: all 0.4s ease
  transform: scale(.9)
  &:hover
    transform: scale(1.1)

.mb-info-right-curtain::-webkit-scrollbar-track
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
	background-color: #0054a3

.mb-info-right-curtain::-webkit-scrollbar
	width: 10px
	background-color: #0054a3

.mb-info-right-curtain::-webkit-scrollbar-thumb
	background-color: #309de4
	border: 2px solid #309de4
</style>
